import { client } from "@/api-client/client.gen";
import { authFetch } from "@/features/auth/session/auth-fetch";
import { getAuthStatus, subscribeToAuthStatus } from "@/features/auth/session/auth-status";
import { queryClient } from "@/lib/query-client";

const CSRF_COOKIE_PATTERN = /(?:^|;\s*)csrftoken=([^;]*)/;
const SAFE_METHODS = new Set(["GET", "HEAD", "OPTIONS"]);

function getCsrfToken(): string | undefined {
  const match = CSRF_COOKIE_PATTERN.exec(document.cookie);
  return match?.[1];
}

export function apiFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const request = new Request(input, init);

  if (import.meta.env["VITE_MOCK_AUTH"] === "true") {
    request.headers.set("X-Debug-User-Email", "demo@nextretail.ai");
  }

  if (!SAFE_METHODS.has(request.method)) {
    const csrfToken = getCsrfToken();
    if (csrfToken) {
      request.headers.set("X-CSRFToken", csrfToken);
    }
  }

  return authFetch(request);
}

client.setConfig({
  baseUrl: "",
  credentials: "include",
  fetch: apiFetch,
});

subscribeToAuthStatus(() => {
  if (getAuthStatus() === "signed_out") {
    queryClient.clear();
  }
});

export { client };
